import { presets } from '@yandex-int/messenger.widget';

import type { RootState } from '../../../init-store';

export const getMessengerOriginPreset = (state: RootState) => {
    const { isOnPremise, messengerBaseUrl } = state.config;

    if (!isOnPremise || !messengerBaseUrl) {
        return undefined;
    }

    return presets.origin.external.local(messengerBaseUrl);
};
